module.exports = __webpack_public_path__ + "assets/img/34_886.3967d2d7.jpg";